class PageMenu extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      menu: this.querySelector('ul'),
    };

    this.headings = document.querySelectorAll('[data-section]');

    for (const heading of this.headings) {
      const identifier = heading.getAttribute('data-section');
      this.modifyElementID(heading, identifier);
      this.elements.menu.appendChild(this.createListItem(identifier));
    }

    // for (const listItem of this.elements.menu.querySelectorAll('li')) {
    //   listItem.addEventListener('click', (event) => {
    //     const current = event.currentTarget.innerHTML;
    //     document.querySelector(`[data-section="${current}"]`).scrollIntoView();
    //   });
    // }
  }

  modifyElementID(element, identifier) {
    element.setAttribute('id', `${this.handleize(identifier)}`);
  }

  modifyElementLink(element, identifier) {
    element.setAttribute('href', `#${this.handleize(identifier)}`);
    element.classList.add(
      'hidden',
      'group-hover:inline',
      'text-[#888888]',
      'hover:text-primary-hover',
      'active:text-primary-pressed',
    );
  }

  createListItem(identifier) {
    const listItemElement = document.createElement('li');
    listItemElement.classList.add(
      'flex',
      'justify-end',
      'items-center',
      "after:content-['']",
      'after:inline-block',
      'after:ml-4',
      'after:rounded-full',
      'after:h-8',
      'after:w-8',
      'after:bg-[#888888]',
    );

    const listAnchorElement = document.createElement('a');
    this.modifyElementLink(listAnchorElement, identifier);
    listAnchorElement.appendChild(document.createTextNode(identifier));
    listItemElement.appendChild(listAnchorElement);

    return listItemElement;
  }

  handleize(string) {
    return string
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-$/, '')
      .replace(/^-/, '');
  }
}

if (!customElements.get('page-menu')) {
  customElements.define('page-menu', PageMenu);
}
